import { IconSearch } from '@tabler/icons-react';

type SearchButtonProps = {
  onClick: () => void;
  hidden?: boolean;
};

export function SearchButton({ onClick, hidden }: SearchButtonProps) {
  if (hidden) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-9 w-[9rem] items-center justify-between rounded-md border border-zinc-200 bg-zinc-100 px-3 text-sm font-normal text-zinc-800 transition-colors hover:bg-zinc-300 lg:w-[16rem] xl:w-[18rem] dark:border-zinc-600 dark:bg-zinc-600 dark:text-zinc-200 dark:hover:bg-zinc-700"
    >
      <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
        <IconSearch
          size={16}
          stroke={1.5}
        />
        <span className="hidden md:inline">Search</span>
      </div>

      <kbd className="hidden h-5 items-center rounded border border-zinc-400 px-2 text-zinc-700 md:flex dark:border-zinc-400 dark:text-zinc-300">
        <span className="relative text-sm">⌘</span>
        <span className="ml-0.5 text-xs">K</span>
      </kbd>
    </button>
  );
}
